<template>

    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="회사명" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="cmpNmRef" v-model="state.managerParams.cmp_nm" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="사업부명">
                <template #end="{id}">
                  <div class="input-group mb-3">
                    <ElInput :id="id" v-model="state.managerParams.cmp_dvsn_nm" readonly/>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이름" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="usrNmRef" v-model="state.managerParams.mngr_nm" @update:modelValue="getNameMask" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="직급" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="positionRef" v-model="state.managerParams.postion" @update:modelValue="getNameMask" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="부서">
                <template #end="{id}">
                  <ElInput :id="id" ref="departNmRef" v-model="state.managerParams.depart_nm" @update:modelValue="getNameMask" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="유선번호">
                <template #end="{id}">
                  <ElInput :id="id" ref="tel" v-model="state.managerParams.tel_no" @update:modelValue="getTeleMask" readonly/>
                </template>
              </ElLabel>
  
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="휴대폰번호" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="mobileRef" 
                    phoneNumber
                    :modelValue="state.managerParams.mobile" 
                    @update:modelValue="getMobileMask"
                    :maxlength="13"
                    readonly
                  />
                </template>
              </ElLabel>
  
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이메일" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="emailRef" v-model="state.managerParams.email" readonly/>
                </template>
              </ElLabel>
  
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="" class="form-label">Keyman</label>
              <SelectCode cd_gr="YN_CD" :matchCd="state.managerParams.keyman_yn" :isShow="false"/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="" class="form-label">고객 성향</label>
              <SelectCode cd_gr="TRD_CD" :matchCd="state.managerParams.trend_cd" :isShow="false"/>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <label for="" class="form-label">재/퇴직여부</label>
              <SelectCode chk_ess='Y' :matchCd="state.managerParams.retire_yn" cd_gr="RTR_CD":isShow="false"/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="마지막 update날짜">
                <template #end="{id}">
                  <DatePicker :id="id" :select-date="state.managerParams.fmt_upd_dt" @return="r => state.managerParams.fmt_upd_dt = r" disabled/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
  
              <ElLabel name="활성화/비활성화">
                <template #end="{id}">
                  <div :id="id" class="radio-btn-toggle d-flex">
  
                    <ElLabel name="활성화" classNm="btn btn-sm flex-fill">
  
                      <template #start="slotProp">
                        <ElRadio
                          v-model="state.managerParams.enable_yn"
                          v-bind="{
                            id:slotProp.id,
                            value:'Y',
                            classNm:'btn-check',
                            name:'options-base',
                          }"
                          @radioChange="r=>test(r)"
                          disabled
                        />
                      </template>
  
                    </ElLabel>
  
                    <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">
  
                      <template #start="slotProp">
                        <ElRadio
                          v-model="state.managerParams.enable_yn"
                          v-bind="{
                            id:slotProp.id,
                            value:'N',
                            classNm:'btn-check',
                            name:'options-base',
                          }"
                          disabled
                        />
                      </template>
  
                    </ElLabel>
                  </div>
                </template>
  
  
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="즐겨찾기">
                <template #end="{id}">
                  <ElButton 
                  type="bookmarkL"
                  :active="state.managerParams.bkmark_yn === 'Y'" 
                  disabled
                  >
                    즐겨찾기 추가
                  </ElButton>
                </template>
              </ElLabel>
              
              <!--  활성화 클래스 btn-active -->
            </div>
          </div>
        </div>
  
        <div class="row band">
          <div class="col-md-9">
            <div class="mb-3">
              <ElLabel name="메모">
                <template #end="{id}">
                  <ElTextarea  
                    :id="id"
                    v-model="state.managerParams.memo"
                    :rows="3" 
                    style="min-height: 11rem"
                    disabled
                  />
                </template>
              </ElLabel>
                
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="명함사진등록">
                <template #end="{id}">
                  <div class="photo-wrap" :id="id">
                    <div class="photo">
                      <a href="" data-bs-toggle="modal" data-bs-target="#Modal-img">
                        <img :src="state.previewImg" v-if="state.previewImg" />
                        <img v-else src="/images/namecard-none.jpg" />
                      </a>
                    </div>
                    <ElButton type="registPhoto">
                      프로필 사진<span class="ic-photo"></span>
                    </ElButton>
                  </div>
                </template>
              </ElLabel>
              
            </div>
          </div>
        </div>
      </div>
      <!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">
          이전
        </ElButton>
      </div>
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <FileUpload ref="fileUploadRef" :can-update="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- <ExcelUploadModal ref="excelUploadModalRef" :colDefs="state.excelModalColDefs" @return="saveAll" /> -->
     <!-- modal:이미지크게보기 -->
  <div class="modal fade" id="Modal-img" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          
          <div class="modal-body text-center">
            
            <img :src="state.previewImg" v-if="state.previewImg" />
            <img v-else src="/images/namecard-none.jpg" />
          </div>

        </div>
      </div>
    </div> 
  </template>
  
<script setup>
import { reactive, ref, onBeforeMount,computed } from "vue";
import DatePicker from "@/components/common/DatePicker.vue";
import FileUpload from "@/components/common/FileUpload.vue";
import { useRouter } from "vue-router";
import SelectCode from "@/components/common/SelectCode.vue";
// import ExcelUploadModal from "@/components/common/modal/ExcelUploadModal.vue";
const router = useRouter();

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { mngSelect } from "@/api/mng";
import { fileList } from "@/api/file";
import { fileDownload } from '@/api/file';
const fileUploadRef = ref();
// const excelUploadModalRef = ref();

const cmpNmRef = ref();
const usrNmRef = ref();
const positionRef = ref();
const departNmRef = ref();
const mobileRef = ref();
const emailRef = ref();

onBeforeMount(async () => {
  let mng_seq = history.state.mng_seq;
  if (mng_seq) {
    searchMngDtl(mng_seq)
  }else{
    alert('잘못된 접근입니다.')
    router.push("/sh/MSH_SR_002")
  }
});

async function searchMngDtl(mng_seq){
  let param = {
      mng_seq: mng_seq,
  }
  try {
    setIsLoading(true)
    const res = await mngSelect(param)
    if(Object.keys(res.rtn).length === 0){
      alert('조회되는 매니저가 없습니다.확인 후 다시 조회해주세요')
      router.push('/sh/MSH_SR_002')
      return
    }

    state.managerParams.mng_seq = res.rtn.mng_seq
    state.managerParams.cp_seq = res.rtn.cp_seq
    state.managerParams.trend_nm = res.rtn.trend_nm
    state.managerParams.postion = res.rtn.postion
    state.managerParams.enable_yn = res.rtn.enable_yn
    state.managerParams.bkmark_yn = res.rtn.bkmark_yn
    state.managerParams.memo = res.rtn.memo
    state.managerParams.mngr_nm = res.rtn.mngr_nm
    state.managerParams.cmp_dvsn_nm = res.rtn.cmp_dvsn_nm
    state.managerParams.tel_no = res.rtn.tel_no
    state.managerParams.email = res.rtn.email
    state.managerParams.keyman_yn = res.rtn.keyman_yn
    state.managerParams.depart_nm = res.rtn.depart_nm
    state.managerParams.attch_pic_id = res.rtn.attch_pic_id
    state.managerParams.trend_cd = res.rtn.trend_cd
    state.managerParams.mobile = res.rtn.mobile
    state.managerParams.fmt_reg_dt = res.rtn.fmt_reg_dt
    state.managerParams.fmt_upd_dt = res.rtn.fmt_upd_dt
    state.managerParams.del_yn = res.rtn.del_yn
    state.managerParams.retire_yn = res.rtn.retire_yn
    state.managerParams.cmp_nm = res.rtn.cmp_nm

    //첨부파일이 존재할경우 파일리스트 조회api 호출
    if (res.rtn.file_seq_grp) {
      let apiParam = {
        file_seq_grp: res.rtn.file_seq_grp,
      }
      try {
        const resFileList = await fileList(apiParam)
        fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn.filter((item) => item.up_path === "/manager/file")
        let profileSeqList = resFileList.rtn.filter((file)=>{
          if(file.up_path === '/manager/profile'){
            return file.file_seq
          }
        })
        let profileSeq = profileSeqList.length ? Math.max(...profileSeqList.map(file => file.file_seq)) : null;
        if(profileSeq){
          const profileRes = await fileDownload(profileSeq)
          if(profileRes){
            state.previewImg =  window.URL.createObjectURL(new Blob([profileRes.data]))
          }
        }
      } catch (err) {
        console.log("파일리스트 조회 api 에러", error)
        alert("파일리스트 조회에 실패했습니다.")
        throw err
      }
    }
  } catch (err) {
    console.log("error", err)
    alert("상세조회 api 에러")
    router.push("/sh/MSH_SR_002")
  } finally {
    setIsLoading(false)
  }
}

const state = reactive({
  managerParams: {
    mng_seq: "",
    cp_seq: "",
    mngr_nm: "",
    postion: "",
    depart_nm: "",
    mobile: "",
    tel_no: "",
    email: "",
    memo: "",
    keyman_yn: "",
    trend_cd: "",
    enable_yn: "Y",
    attch_pic_id: "",
    ss_user_id: "",
    bkmark_yn: "Y",
    retire_yn: "N",
    cmp_nm: "",
    cmp_dvsn_nm: "",
    status: "",
    cmp_info_seq: "",
    tmp_yn: "N",
    profilePath: "",
    attachFileVO: {
      file_seq: "", //추가 된 파일 seq 전송
      del_file_seq: "", // 삭제해야 할 파일 seq 전송
      file_div_id: "10",
    },
  },
  fileSeqList: [],
  delFileList: [], //수정 -> 삭제 첨부파일 seq array
  previewImg: "",
  excelModalColDefs: [
    { header: "회사명", field: "cmp_nm", req: true },
    { header: "사업부명", field: "cmp_dvsn_nm" },
    { header: "이름", field: "mngr_nm", type: 'spec', req: true },
    { header: "직급", field: "postion", req: true },
    { header: "부서", field: "depart_nm", req: true },
    { header: "유선번호", field: "tel_no", type: 'telPhone' },
    { header: "휴대폰번호", field: "mobile", type: 'phone', req: true },
    { header: "이메일", field: "email", type: 'email', req: true },
    { header: "keyman", field: "keyman_yn" },
    { header: "고객성향", field: "trend_cd" },
    { header: "재/퇴직여부", field: "retire_yn" },
    { header: "활성화/비활성화", field: "enable_yn", type: 'yn' },
    { header: "즐겨찾기", field: "bkmark_yn" },
    { header: "메모", field: "memo" },
  ],
  excelModalData: [],
});

//이메일 형식
const getEmailMark = (data) => {
  if(!common.checkEmail(data)){
    alert("이메일 형식을 확인해주세요")
    return false
  }else{
    state.managerParams.email
  }
}

//특수문자
const getNameMask = (data) => {
  if (data != undefined && data != "") {
    if (
      state.managerParams.mngr_nm ||
      state.managerParams.postion ||
      state.managerParams.depart_nm
    ) {
      state.managerParams.mngr_nm = common.checkSpecChar(
        state.managerParams.mngr_nm
      )
      state.managerParams.postion = common.checkSpecChar(
        state.managerParams.postion
      )
      state.managerParams.depart_nm = common.checkSpecChar(
        state.managerParams.depart_nm
      )
    }
  }
}
</script>
  